import { fromJS, Map, List } from 'immutable';

export function request(state, { id }) {
    let collections = state.get('collections') || Map();
    let collection = collections.get(id) || Map();

    collections = collections.set(
        id,
        collection
            .set('state', 'IN_PROGRESS')
            .set('items', List())
    );

    return state.set('collections', collections);
}

export function error(state, { id, errors }) {
    let collections = state.get('collections') || Map();
    let collection = collections.get(id) || Map();

    collections = collections.set(
        id,
        collection
            .set('state', 'ERROR')
            .set('errors', fromJS(errors))
    );

    return state.set('collections', collections);
}

export function finish(state, { id, definitions }) {
    let collections = state.get('collections') || Map(),
        collection = collections.get(id) || Map(),
        items = state.get('items') || Map();

    collection = collection
        .set('items', Map())
        .set('state', 'FINISHED');

    Object.keys(definitions).forEach(tag => {
        items = items.set(
            tag,
            (items.get(tag) || Map())
                .merge(fromJS(definitions[tag]))
        );

        collection = collection.set(
            'items',
            collection.get('items').set(tag, fromJS(definitions[tag].values))
        );
    });

    return state
        .set('items', items)
        .set('collections', collections.set(id, collection));
}
